import { Link } from "react-router-dom";
import { imgSrc, formatDate } from "@/lib/api";

const FALLBACK = "https://images.unsplash.com/photo-1586339949916-3e9457bef6d3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=1080";

export const Cover = ({ url, className }) => (
  <img src={imgSrc(url) || FALLBACK} alt="" className={`w-full h-full object-cover ${className || ""}`}
    onError={(e) => { e.currentTarget.src = FALLBACK; }} />
);

export const Eyebrow = ({ cat }) =>
  cat ? <span className="text-[11px] font-bold tracking-[0.18em] uppercase text-[#C8102E]">{cat.name}</span> : null;

export const ArticleCard = ({ a, i }) => (
  <Link to={`/berita/${a.slug}`} data-testid={`article-card-${a.id}`} className="group block fade-up" style={{ animationDelay: `${i * 60}ms` }}>
    <div className="aspect-[16/10] overflow-hidden bg-slate-100 img-zoom"><Cover url={a.image_url} /></div>
    <div className="pt-4 space-y-2">
      <Eyebrow cat={a.category} />
      <h3 className="font-serif text-lg sm:text-xl font-semibold leading-snug text-slate-900 group-hover:text-[#C8102E] transition-colors">{a.title}</h3>
      <p className="text-xs text-slate-500">{formatDate(a.created_at)}</p>
    </div>
  </Link>
);
